import React from 'react';

import ErrorIcon from '@/assets/images/icons/error.svg';

import styles from './styles.module.scss';

const NetworkError = () => (
  <div className={styles.error}>
    <div className={styles.container}>
      <ErrorIcon className={styles.icon} />
      <p>Возникла проблема с запросом данных.</p>
      <p>Перезагрузите страницу.</p>
    </div>
  </div>
);

export default NetworkError;
